import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import {
  CpBody01Primary,
  CpBody02Primary,
  CpBody03Placeholder,
  CpHeading03Primary,
} from 'components/atoms/customer-portal/typography';
import { useGetBackground } from 'components/organisms/customer-portal/types/utils';
import { CpSectionWrapper } from '../../common';
import { CpFaqVariantWidgetProps } from '../cp-faq-types';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--cp-spacing-06);

  @media (max-width: 480px) {
    gap: var(--cp-spacing-03);
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--cp-spacing-03);

  @media (max-width: 480px) {
    gap: var(--cp-spacing-03);
  }
`;

const Title = styled(CpHeading03Primary)`
  margin-bottom: 0;
`;

const Subtitle = styled(CpBody03Placeholder)`
  margin-bottom: 0;
`;

const FaqQuestion = styled(CpBody02Primary)`
  margin-bottom: 0;
`;

const FaqAnswer = styled(CpBody01Primary)`
  color: var(--cp-text-secondary);
  margin-bottom: 0;
`;

const QaList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 24px 48px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    grid-gap: 0;
  }
`;

const QaWrapper = styled.div`
  padding: var(--cp-spacing-07) 0;
  display: flex;
  flex-direction: column;
  gap: var(--cp-spacing-05);

  @media (max-width: 480px) {
    border-bottom: solid 1px var(--cp-border-subtle-auto-adjust);
    padding: var(--cp-spacing-05) 0;
  }
`;

export const CpFaqGrid: React.FC<CpFaqVariantWidgetProps> = ({
  data,
  widget,
}) => {
  const { questionsAndAnswers, title, description } = data;
  const background = useGetBackground(widget);

  return (
    <CpSectionWrapper
      className="rl-cp-faq-widget"
      background={background}
      paddingY={
        widget?.widgetDefinition?.styles?.paddingY as number | undefined
      }
      data-builder-mode-full-tile="true"
    >
      <Wrapper>
        <TitleWrapper>
          <Title data-cy="cp.faq_grid.title" autoAdjustColor>
            {title}
          </Title>
          <Subtitle data-cy="cp.faq_grid.description" autoAdjustColor>
            {description}
          </Subtitle>
        </TitleWrapper>

        <QaList>
          {questionsAndAnswers && _.isArray(questionsAndAnswers) ? (
            questionsAndAnswers.map((qa, index) => (
              <QaWrapper data-cy={`cp.faq_grid.item.${index}`}>
                <FaqQuestion
                  data-cy={`cp.faq_grid.item.${index}.question`}
                  autoAdjustColor
                >
                  {qa.question}
                </FaqQuestion>
                <FaqAnswer
                  data-cy={`cp.faq_grid.item.${index}.answer`}
                  autoAdjustColor
                >
                  {qa.answer}
                </FaqAnswer>
              </QaWrapper>
            ))
          ) : (
            <></>
          )}
        </QaList>
      </Wrapper>
    </CpSectionWrapper>
  );
};
